import styled from '@emotion/styled';

export const StyledCopyToClipboard = styled.div`
  cursor: pointer;
`;
